import React from 'react';
import PropTypes from 'prop-types';
import style from './style.scss';//NOSONAR

const TechnicalTable = (props) => {
    const { product } = props;

    return (
        <>
            {product.flag_technical && <div className="product-page-container-technical-information">
                <div className="technical-information-container-title">
                    <span className="technical-information-title">Ficha Técnica</span>
                </div>
                        
                <div className="technical-information-flags">
                    {product.flag_technical && product.flag_technical.map((item, i) => {
                        return (
                            <div key={i} className="technical-information-flags-container">
                                <div className="technical-information-flags-title-container">
                                    <span className="technical-information-flags-title">{item}</span>
                                </div>
                                <div className="technical-information-flags-value-container">
                                    <span className="technical-information-flags-value">{product[item]}</span>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>}
        </>
    )


}

TechnicalTable.propTypes = {
    product: PropTypes.object,
};

export default TechnicalTable;
